export const BILLS_PATH = "bills";
export const PACKING_LISTS_PATH = "packing-lists";
export const ACT_LISTS_PATH = "service-acts";
export const CONTRACTS_PATH = "contracts";
export const EXPORT_PATH = "export";
export const KSES_PATH = "kses"
